var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-indicator"},[_c('div',{staticClass:"indicator",style:(`width: ${_vm.step}%`)})])
}
var staticRenderFns = []

export { render, staticRenderFns }